/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import styled from "@emotion/styled"
import theme from "../styles/theme"

import Nav from "./Nav"
import Footer from "./Footer"

const Container = styled.main`
  > * + * {
    margin-top: 64px;
  }
  @media (max-width: ${theme.breakpoints.tablet}) {
    padding-top: 128px;
  }
`

const Layout = ({ children }) => {
  return (
    <>
      <Nav></Nav>

      <Container>{children}</Container>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
